<template>
  <div class="wrapper">
    <!-- 有权限 -->
    <template v-if="is_auth">
      <!-- 数据概览 -->
      <div class="overview-box">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card>
              <template #header>
                <div class="card-header">
                  <span>今日收入</span>
                  <span>￥{{ statResult.incomeData?.dayTotalFee }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>正常租金</span>
                  <span>￥{{ statResult.incomeData?.dayNormalBillFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>逾期租金</span>
                  <span>￥{{ statResult.incomeData?.dayOverdueBillFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>其他收入</span>
                  <span>￥{{ statResult.incomeData?.dayOtherFee }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计收入</span>
                <span>￥{{ statResult.incomeData?.yearTotalFee }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card>
              <template #header>
                <div class="card-header">
                  <span>今日支出</span>
                  <span>￥{{ statResult.incomeData?.dayTotalFee }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>采购成本</span>
                  <span>￥{{ statResult.incomeData?.dayTotalFee }}</span>
                </p>
                <p class="card-content-item">
                  <span>其他支出</span>
                  <span>￥{{ statResult.incomeData?.dayOtherFee }}</span>
                </p>
                <p class="card-content-item"></p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计支出</span>
                <span>￥{{ statResult.incomeData?.yearTotalFee }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card>
              <template #header>
                <div class="card-header">
                  <span>今日订单</span>
                  <span>{{ statResult.orderData?.dayCreateNum }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>成单数量</span>
                  <span>{{ statResult.orderData?.dayDealNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>成单转化率</span>
                  <span>{{ statResult.orderData?.dayDealRate || '-' }}%</span>
                </p>
                <p class="card-content-item">
                  <span>当前逾期</span>
                  <span>{{ statResult.orderData?.totalOverdueNum }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本年累计成单</span>
                <span>{{ statResult.orderData?.yearDealNum }}</span>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card>
              <template #header>
                <div class="card-header">
                  <span>门店总数</span>
                  <span>{{ statResult.storeData?.totalNum }}</span>
                </div>
              </template>
              <div class="card-content">
                <p class="card-content-item">
                  <span>今日新增</span>
                  <span>{{ statResult.storeData?.dayIncrNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>今日成单</span>
                  <span>{{ statResult.storeData?.dayDealNum }}</span>
                </p>
                <p class="card-content-item">
                  <span>当前逾期</span>
                  <span>{{ statResult.storeData?.totalOverdueNum }}</span>
                </p>
              </div>
              <div class="card-divider"></div>
              <div class="card-footer">
                <span>本月累计新增</span>
                <span>{{ statResult.storeData?.monthIncrNum }}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 图表展示 -->
      <div class="chart-box">
        <div class="chart-item">
          <LineChart
              v-if="show"
              title="下单/成单统计"
              :list_x="statResult.orderChartLine?.xaxis || []"
              series_name="下单数量"
              :list_y="statResult.orderChartLine?.yaxis || []"
              series_name2="成单数量"
              :list_y2="statResult.orderChartLine?.yaxis2 || []"
              dataType="number"
          ></LineChart>
        </div>
        <div class="chart-item">
          <LineChart
              v-if="show"
              :list_x="statResult.billPayRateChartLine?.xaxis || []"
              series_name="缴纳率"
              :list_y="statResult.billPayRateChartLine?.yaxis || []"
              title="账单缴纳率统计"
              dataType="percent"
          ></LineChart>
        </div>
      </div>

      <!-- 排行榜 -->
      <div class="rank-box">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card>
              <template #header>
                <div class="rank-header">
                  <span>门店成交金额排行榜</span>
                </div>
              </template>
              <div class="rank-content">
                <div class="rank-content-item" v-for="(item, i) in statResult.storeRankList" :key="i">
                  <div class="col1">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="col2">
                    <div class="name">{{ item.storeName }}</div>
                    <div class="num">开店时间：{{ item.createTime }}</div>
                  </div>
                  <div class="col3">订单数：{{ item.orderDealNum }}</div>
                  <div class="col4">订单金额：￥{{ item.orderDealAmount }}</div>
                </div>
                <el-empty v-if="!statResult.storeRankList || statResult.storeRankList.length == 0" description="暂无数据"></el-empty>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card>
              <template #header>
                <div class="rank-header">
                  <span>产品成交数量排行榜</span>
                </div>
              </template>
              <div class="rank-content">
                <div class="rank-content-item" v-for="(item, i) in statResult.goodsRankList" :key="i">
                  <div class="col1">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="col2">
                    <div class="name">{{ item.goodsName }}</div>
                  </div>
                  <div class="col3">订单数：{{ item.orderDealNum }}</div>
                  <div class="col4">订单金额：￥{{ item.orderDealAmount }}</div>
                </div>
                <el-empty v-if="!statResult.goodsRankList || statResult.goodsRankList.length == 0" description="暂无数据"></el-empty>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </template>
    <!-- 无权限 -->
    <template v-else>
      <el-empty description="敬请期待"></el-empty>
    </template>
  </div>
</template>

<script>
import { getHomeStatAPI } from './api';
import LineChart from './LineChart/LineCharts.vue';

export default {
  name: 'Home',
  components: { LineChart },
  data() {
    return {
      show: false,
      current_date: 1,
      statResult: {},
    }
  },
  computed: {
    is_auth() {
      const authMenus = this.$store.state.user.authMenus;
      const is_admin = this.$store.state.user.isAdmin;
      const res = authMenus.indexOf('Home');
      return is_admin == 1 || res > -1;
    },
    today() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 0);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
    today1() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 1);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
    today2() {
      // 获取当前日期
      let today = new Date();

      // 减去一天
      today.setDate(today.getDate() - 2);

      // 格式化为YYYY-MM-DD格式
      return today.toISOString().split('T')[0];
    },
  },
  mounted() {
    this.getHomeStat();
  },
  filters: {
    todayName(val) {
      let arr = val.split('-');
      return arr[1] + '月' + arr[2] + '日';
    }
  },
  methods: {
    async getHomeStat() {
      if (!this.is_auth) return;
      this.statResult = await getHomeStatAPI();
      this.show = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  ::v-deep .el-card__header {
    padding: 12px 20px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .overview-box {
    margin-top: 20px;
    font-size: 14px;
    line-height: 22px;

    .card-header {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
    }

    .card-content {
      padding: 12px 20px;
    }

    .card-content-item {
      display: flex;
      justify-content: space-between;
      min-height: 22px;
    }

    .card-divider {
      border-top: 1px solid #EBEEF5;
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      padding: 12px 20px;
    }
  }

  .chart-box {
    margin-top: 20px;
    display: flex;
    gap: 20px;

    .chart-item {
      flex: 1;
      height: 300px;
      border: 1px solid #EBEEF5;
    }
  }

  .rank-box {
    margin-top: 20px;
    padding-bottom: 20px;

    .rank-content {
      min-height: 200px;

      .rank-content-item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ebeef5;
        padding: 10px 20px;
        &:last-child {
          border-bottom: none;
        }
        .col1 {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-weight: 600;
          padding: 0 5px;
          width: 70px;
          img {
            width: 40px;
            height: 24px;
          }
          span {
            width: 40px;
            display: block;
            text-align: center;
          }
        }
        .col2 {
          padding: 0 5px;
          flex: 2;
          .name {
            font-size: 15px;
            font-weight: 700;
          }
          .num {
            font-size: 13px;
          }
        }
        .col3 {
          padding: 0 5px;
          flex: 1;
        }
        .col4 {
          padding: 0 5px;
          flex: 1;
        }
      }
    }
  }
}
</style>
